module.exports = __webpack_public_path__ + "assets/img/Exchange_tit.8c2010aa.png";